module.exports = {"id":"202599","name":"Igor Coronado","rating":"73","photo":"./data/images/photos/3/202599.png","club":{"name":"Palerme","logo":"./data/images/clubs/Palerme.png"},"positions":["MOC","ATT","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgorCoronado0.json
// module id = 1787
// module chunks = 0